import styled from "@emotion/styled";
import { fontRobotoCondensed, theme } from "@product/scmp-sdk";

import { BaseEntityLink } from "shared/components/common/base-entity-link";

export const ArticleTypeName = styled.span`
  color: #666666;
`;

export const StyledBaseEntityLink = styled(BaseEntityLink)`
  color: #aaaaaa;
  &:after {
    content: "/";

    margin-inline: 6px;
  }
`;

export const Container = styled.div`
  ${StyledBaseEntityLink}, ${ArticleTypeName} {
    font-size: 18px;
    font-family: ${fontRobotoCondensed};
    line-height: 21px;

    ${theme.breakpoints.up("tablet")} {
      font-size: 24px;
      line-height: 39px;
    }
  }
`;
